import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

// CHANGED: Add a fallback to '/' so that the app never crashes 
// if the env variable is missing or set to something like "/static/"
const router = createBrowserRouter(
  [MainRoutes, LoginRoutes], 
  { 
    basename: import.meta.env.VITE_APP_BASE_NAME === '/static/' 
      ? '/' 
      : (import.meta.env.VITE_APP_BASE_NAME || '/') 
  }
);

export default router;
